import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const Bar = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  padding: 2.4rem 4.6rem;
  min-height: 15.1rem;
  border-bottom: 1px solid ${({ theme }) => theme.colors.offBlack};
  background: #223654;

  @media (max-width: ${({ theme }) => theme.sizes.lg}) {
    flex-direction: column;
    gap: 2.4rem;
    padding: 2rem 1.6rem;
    min-height: auto;
  }
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  gap: 4.6rem;
  position: relative;
  z-index: 1;

  @media (max-width: ${({ theme }) => theme.sizes.lg}) {
    flex-wrap: wrap;
    justify-content: center;
    gap: 2.4rem 3.2rem;
    width: 100%;
  }
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  text-transform: uppercase;

  @media (max-width: ${({ theme }) => theme.sizes.lg}) {
    align-items: center;
    text-align: center;
    order: 1;
  }
`;

export const DiscountText = styled.p`
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-weight: ${({ theme }) => theme.fonts.weight.bolder};
  font-size: 5.4rem;
  color: ${({ theme }) => theme.colors.primary.main};
  margin: 0;
  line-height: 1;

  @media (max-width: ${({ theme }) => theme.sizes.lg}) {
    font-size: 3.6rem;
  }
`;

export const SubscriptionText = styled.p`
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
  font-size: 2.6rem;
  color: ${({ theme }) => theme.colors.white};
  margin: 0;
  line-height: 1;

  @media (max-width: ${({ theme }) => theme.sizes.lg}) {
    font-size: 1.8rem;
  }
`;

export const SubscribeBtn = styled(Link)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 1rem 3.6rem;
  border-radius: 0.4rem;
  background: linear-gradient(180deg, #ffd966 0%, #f4b942 100%);
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  font-size: ${({ theme }) => theme.fonts.sizes.large};
  color: ${({ theme }) => theme.colors.offBlack};
  text-decoration: none;
  white-space: nowrap;
  transition: transform 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    background: linear-gradient(180deg, #ffe680 0%, #f5c256 100%);
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: ${({ theme }) => theme.sizes.lg}) {
    font-size: ${({ theme }) => theme.fonts.sizes.medium};
    padding: 0.8rem 2.4rem;
    order: 3;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  right: 2.4rem;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0.8rem;
  color: ${({ theme }) => theme.colors.white};
  transition: opacity 0.2s ease;
  z-index: 2;

  &:hover {
    opacity: 0.7;
  }

  svg {
    display: block;
    width: 2.1rem;
    height: 2.4rem;
  }

  @media (max-width: ${({ theme }) => theme.sizes.lg}) {
    right: 1.6rem;
    top: 1.6rem;
    transform: none;
  }
`;
